import {Component, OnInit, HostListener} from '@angular/core';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {ModalService} from '../../../service/modal.service';
import {GlobalService} from '../../../service/global.service';
import {CatalogoApiService} from '../../../service/api/catalogo.api';
import {Router, ActivatedRoute} from '@angular/router';
import {Operacao, ParametroEntradaOperacao, ParametroSaidaOperacao, ReturnCode} from '../../../model/catalogo';
import {Subscription} from 'rxjs/Subscription';
import {DetalhamentoApiService} from '../../../service/api/detalhamento.api';

@Component({
    selector: 'cadastro-operacao',
    templateUrl: './cadastro-operacao.component.html',
    styleUrls: ['./cadastro-operacao.component.css']
})
export class CadastroOperacaoComponent {

    modoEdicao: Boolean = false;
    collapseNovo: boolean = false;
    collapseNovoSaida: boolean = false;
    collapseReturnCode: boolean = false;
    paramsSubscription: Subscription = null;

    nome = new FormControl('', []);
    descricao = new FormControl('', []);
    tipoEdicao = new FormControl('0', []);
    codigo: number = null;
    versao: number = null;
    titulo: string;
    edicaoEntrada: number = null;
    edicaoSaida: number = null;
    edicaoReturnCode: number = null;

    parmNome = new FormControl('', []);
    parmDesc = new FormControl('', []);
    paramTipo = new FormControl('', []);
    paramSubtipo = new FormControl('', []);
    paramObrigatorio = new FormControl('', []);
    conteudoPadrao = new FormControl('', []);

    parmSaidaNome = new FormControl('', []);
    parmSaidaDesc = new FormControl('', []);
    paramSaidaTipo = new FormControl('', []);
    paramSaidaSubtipo = new FormControl('', []);

    paramReturnCodeNum = new FormControl('', []);
    paramReturnCodeDesc = new FormControl('', []);

    operacaoForm: FormGroup = this.formBuilder.group({
        nome: this.nome,
        descricao: this.descricao,
    });
    parametroReturnCodeForm: FormGroup = this.formBuilder.group({
        paramReturnCodeNum: this.paramReturnCodeNum,
        paramReturnCodeDesc: this.paramReturnCodeDesc,
    });
    conteudoPadraoForm: FormGroup = this.formBuilder.group({
        conteudoPadrao: this.conteudoPadrao,
    });
    parametroForm: FormGroup = this.formBuilder.group({
        parmNome: this.parmNome,
        parmDesc: this.parmDesc,
        paramTipo: this.paramTipo,
        paramSubtipo: this.paramSubtipo,
        paramObrigatorio: this.paramObrigatorio,
    });
    parametroSaidaForm: FormGroup = this.formBuilder.group({
        parmSaidaNome: this.parmSaidaNome,
        parmSaidaDesc: this.parmSaidaDesc,
        paramSaidaTipo: this.paramSaidaTipo,
        paramSaidaSubtipo: this.paramSaidaSubtipo,
    });


    novaOperacao: Operacao = new Operacao();
    novoParametro: ParametroEntradaOperacao = new ParametroEntradaOperacao();
    listaParametrosEntrada: Array<ParametroEntradaOperacao> = new Array<ParametroEntradaOperacao>();
    novoParametroSaida: ParametroSaidaOperacao = new ParametroSaidaOperacao();
    listaParametrosSaida: Array<ParametroSaidaOperacao> = new Array<ParametroSaidaOperacao>();
    listaConteudoPadrao: Array<string> = new Array<string>();
    novoParametroReturnCode: ReturnCode = new ReturnCode();
    listaParametrosReturnCode: Array<ReturnCode> = new Array<ReturnCode>();

    constructor(private globalService: GlobalService, private router: Router, private route: ActivatedRoute, public modalService: ModalService, private formBuilder: FormBuilder, private catalogoService: CatalogoApiService, public detalhamentoApiService: DetalhamentoApiService) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13 && this.operacaoForm.valid) {
                this.salvarOperacao();
            } else {
            }
        }
    }

    ngOnInit() {
        this.modalService.fecharPaginaModal();
        this.paramsSubscription = this.route.params.subscribe(params => {
            if (params['codigo'] != undefined) {
                this.modoEdicao = true;
                this.novaOperacao.codigo = params['codigo'];
                this.novaOperacao.versao = params['versao'];
                this.getDadosOperacao(params['codigo'], params['versao']);
                this.titulo = 'Editar Operação';
            } else {
                this.titulo = 'Nova Operação';
            }
        });
    }

    ngOnDestroy() {
        if (this.paramsSubscription != null) {
            this.paramsSubscription.unsubscribe();
        }
    }

    getDadosOperacao(codigo: number, versao: number) {
        this.detalhamentoApiService.detalhaOperacao(codigo, versao)
            .subscribe(response => {
                    this.codigo = response.codigo;
                    this.versao = response.versao;
                    this.nome.setValue(response.nome.trim());
                    this.descricao.setValue(response.descricao.trim());
                    this.listaParametrosEntrada = [];
                    this.listaParametrosEntrada = response.parmEntrada;
                    this.listaParametrosSaida = [];
                    this.listaParametrosSaida = response.parmSaida;
                    this.listaParametrosReturnCode = [];
                    this.listaParametrosReturnCode = response.returnCode;
                },
                erro => {
                });
    }

    salvarOperacao() {

        this.modalService.fecharPaginaModal();

        this.novaOperacao.nome = this.operacaoForm.value.nome;
        this.novaOperacao.descricao = this.operacaoForm.value.descricao;

        this.novaOperacao.parmEntrada = this.listaParametrosEntrada;
        this.novaOperacao.parmSaida = this.listaParametrosSaida;

        if (this.listaParametrosReturnCode.length <= 0) {
            this.modalService.exibirMensagem('Erro', 'Adicione no mínimo 01 (um) ReturnCode!', 'Fechar');
            return false;
        }

        this.novaOperacao.returnCode = this.listaParametrosReturnCode;

        if (this.modoEdicao) {
            var msgLayoutArquivo: string = 'Por padrão, a alteração é gravada nesta mesma versão da operação. Se optar por gravar em uma nova versão, os FTAs que atualmente apontam para esta instalação vão manter uso dos parâmetros e definições da versão antiga. Deseja manter a mesma versão vigente ?';
            this.modalService.abrirPaginaModal('edicao-artefatos-modal', {}, {
                    'pesquisar': false,
                    'mensagem': msgLayoutArquivo
                },
                'Confirmação !', 'Fechar')
                .subscribe(resp => {
                    if (resp.tipoEdicao) {
                        this.novaOperacao.codigo = this.codigo;
                        this.novaOperacao.versao = this.versao;
                    } else {
                        this.novaOperacao.codigo = 0;
                        this.novaOperacao.versao = 0;
                    }
                    this.criaEditaOperacao();
                });
        } else {
            this.novaOperacao.codigo = 0;
            this.novaOperacao.versao = 0;
            this.criaEditaOperacao();
        }
    }

    criaEditaOperacao() {
        this.modalService.fecharPaginaModal();
        this.catalogoService.criaEditaOperacao(this.novaOperacao.codigo, this.novaOperacao.versao, this.novaOperacao)
            .subscribe(
                resposta => {
                    this.modalService.exibirMensagem('Operação', 'Operação atualizada com sucesso!', 'Fechar');
                    this.voltar();
                },
                erro => {
                    if (erro.status == 400) {
                        this.modalService.exibirMensagem('Operação', 'Erro ao cadastrar operação.<br />Verifique se os campos foram preenchidos corretamente.', 'Fechar');
                    } else if (erro.status == 401) {
                        this.modalService.exibirMensagem('Operação', 'Erro ao cadastrar operação.<br />Token de autenticação fora do formato esperado, inválido ou expirado.', 'Fechar');
                    } else if (erro.status == 403) {
                        this.modalService.exibirMensagem('Operação', 'Erro ao cadastrar operação.<br />Usuário não possui permissão para efetuar essa operação.', 'Fechar');
                    } else if (erro.status == 409) {
                        this.modalService.exibirMensagem('Operação', 'Erro ao cadastrar operação.<br />Código/Versão incorretos.', 'Fechar');
                    } else {
                        this.modalService.exibirMensagem('Operação', 'Erro ao cadastrar operação.<br />Erro interno do servidor.', 'Fechar');
                    }
                }
            );
    }

    showNovoParametro() {
        if (this.collapseNovo) {
            this.collapseNovo = false;
        } else {
            this.collapseNovo = true;
        }
    }

    showNovoParametroSaida() {
        if (this.collapseNovoSaida) {
            this.collapseNovoSaida = false;
        } else {
            this.collapseNovoSaida = true;
        }
    }

    showNovoReturnCode() {
        if (this.collapseReturnCode) {
            this.collapseReturnCode = false;
        } else {
            this.collapseReturnCode = true;
        }
    }

    voltar() {
        this.router.navigate(['/artefato-operacao']);
    }

    addParametro() {
        this.novoParametro.nome = this.parametroForm.value.parmNome;
        this.novoParametro.descricao = this.parametroForm.value.parmDesc;
        this.novoParametro.nomeTipoDado = this.parametroForm.value.paramTipo;
        this.novoParametro.nomeSubtipoDado = this.parametroForm.value.paramSubtipo;

        if (this.parametroForm.value.paramObrigatorio == 1) {
            this.novoParametro.obrigatorio = true;
        } else {
            this.novoParametro.obrigatorio = false;
        }
        this.novoParametro.conteudoPadrao = this.listaConteudoPadrao;

        if (this.edicaoEntrada != null) {
            this.listaParametrosEntrada[this.edicaoEntrada] = this.novoParametro;
        } else {

            let obj = this.listaParametrosEntrada.find(value => value.nome.replace(/\s/g, '') == this.parametroForm.value.parmNome.replace(/\s/g, ''));

            if (obj) {
                this.modalService.exibirMensagem('Parâmetros de Entrada:', 'Parâmetros de entrada não podem possuir o mesmo nome!', 'Fechar');
                return;
            }

            this.listaParametrosEntrada.push(this.novoParametro);
        }

        this.novoParametro = new ParametroEntradaOperacao();
        this.edicaoEntrada = null;
        this.parametroForm.controls['parmNome'].reset();
        this.parametroForm.controls['parmDesc'].reset();
        this.parametroForm.controls['paramTipo'].reset();
        this.parametroForm.controls['paramSubtipo'].reset();
        this.parametroForm.controls['paramObrigatorio'].reset();
        this.collapseNovo = false;
    }

    addParametroSaida() {
        this.novoParametroSaida.nome = this.parametroSaidaForm.value.parmSaidaNome;
        this.novoParametroSaida.descricao = this.parametroSaidaForm.value.parmSaidaDesc;
        this.novoParametroSaida.nomeTipoDado = this.parametroSaidaForm.value.paramSaidaTipo;
        this.novoParametroSaida.nomeSubtipoDado = this.parametroSaidaForm.value.paramSaidaSubtipo;
        if (this.edicaoSaida != null) {
            this.listaParametrosSaida[this.edicaoSaida] = this.novoParametroSaida;
        } else {
            let obj = this.listaParametrosSaida.find(value => value.nome.replace(/\s/g, '') == this.novoParametroSaida.nome.replace(/\s/g, ''));

            if (obj) {
                this.modalService.exibirMensagem('Parâmetros de saida:', 'Parâmetros de saida não podem possuir o mesmo nome!', 'Fechar');
                return;
            }

            this.listaParametrosSaida.push(this.novoParametroSaida);
        }

        this.edicaoSaida = null;
        this.novoParametroSaida = new ParametroSaidaOperacao();
        this.parametroSaidaForm.controls['parmSaidaNome'].reset();
        this.parametroSaidaForm.controls['parmSaidaDesc'].reset();
        this.parametroSaidaForm.controls['paramSaidaTipo'].reset();
        this.parametroSaidaForm.controls['paramSaidaSubtipo'].reset();
        this.collapseNovoSaida = false;
    }

    addParametroReturnCode() {
        this.novoParametroReturnCode.rc = this.parametroReturnCodeForm.value.paramReturnCodeNum;
        this.novoParametroReturnCode.descricao = this.parametroReturnCodeForm.value.paramReturnCodeDesc;

        if (this.edicaoReturnCode != null) {
            this.listaParametrosReturnCode[this.edicaoReturnCode] = this.novoParametroReturnCode;
        } else {

            let obj = this.listaParametrosReturnCode.find(value => value.rc == this.novoParametroReturnCode.rc);

            if (obj) {
                this.modalService.exibirMensagem('Return Code:', 'Return Code a não pode possuir o mesmo código!', 'Fechar');
                return;
            }

            this.listaParametrosReturnCode.push(this.novoParametroReturnCode);
        }

        this.novoParametroReturnCode = new ReturnCode();
        this.parametroReturnCodeForm.controls['paramReturnCodeNum'].reset();
        this.parametroReturnCodeForm.controls['paramReturnCodeDesc'].reset();

        this.collapseReturnCode = false;
    }

    addConteudoPadrao() {
        this.listaConteudoPadrao.push(this.conteudoPadraoForm.value.conteudoPadrao);
        this.conteudoPadraoForm.controls['conteudoPadrao'].reset();
    }

    removerParametroEntrada(indice: number) {
        this.edicaoEntrada = null;
        this.collapseNovo = false;
        this.listaParametrosEntrada.splice(indice, 1);
    }

    editarParametroEntrada(indice: number) {
        let dados = this.listaParametrosEntrada[indice];
        this.parmNome.setValue(dados.nome);
        this.parmDesc.setValue(dados.descricao);
        this.paramTipo.setValue(dados.nomeTipoDado);
        this.paramSubtipo.setValue(dados.nomeSubtipoDado);
        this.listaConteudoPadrao = dados.conteudoPadrao;
        if (dados.obrigatorio == true) {
            this.paramObrigatorio.setValue('1');
        } else {
            this.paramObrigatorio.setValue('0');
        }
        this.edicaoEntrada = indice;
        this.collapseNovo = true;
    }

    removerParametroReturnCode(indice: number) {
        this.edicaoReturnCode = null;
        this.collapseReturnCode = false;
        this.listaParametrosReturnCode.splice(indice, 1);
    }

    editarParametroReturnCode(indice: number) {
        let dados = this.listaParametrosReturnCode[indice];
        this.paramReturnCodeNum.setValue(dados.rc);
        this.paramReturnCodeDesc.setValue(dados.descricao);
        this.edicaoReturnCode = indice;
    }

    removerParametroSaida(indice: number) {
        this.edicaoSaida = null;
        this.collapseNovoSaida = false;
        this.listaParametrosSaida.splice(indice, 1);
    }

    editarParametroSaida(indice: number) {
        let dados = this.listaParametrosSaida[indice];
        this.parmSaidaNome.setValue(dados.nome);
        this.parmSaidaDesc.setValue(dados.descricao);
        this.paramSaidaTipo.setValue(dados.nomeTipoDado);
        this.paramSaidaSubtipo.setValue(dados.nomeSubtipoDado);

        this.edicaoSaida = indice;
        this.collapseNovoSaida = true;
    }


    removerConteudoPadrao(indice: number) {
        this.listaConteudoPadrao.splice(indice, 1);
    }

}



// WEBPACK FOOTER //
// ./src/app/artefato/cadastro-operacao/cadastro-operacao.component.ts